/**
 * Etiqueta de un nivel de precio en la interfaz. Una fila del catálogo es un par
 * (peldaño, segmento): el número dice qué tan hondo es el descuento y el nombre, a qué tipo de
 * cliente corresponde. Se muestran juntos siempre, porque varios segmentos comparten peldaño y el
 * número solo no identifica a ninguno — "Nivel 2" puede ser Preferente o Conviene.
 */
// level llega null cuando el nivel referenciado ya fue eliminado: se rotula "Nivel eliminado" en vez de imprimir un número inexistente.
export const priceLevelLabel = (priceLevel: { level: number | null; name?: string | null }): string => {
  if (priceLevel.level == null) return 'Nivel eliminado'

  return priceLevel.name ? `Nivel ${priceLevel.level} — ${priceLevel.name}` : `Nivel ${priceLevel.level}`
}
